export default "__VITE_ASSET__LHdNstan__"